// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-balance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-balance/weight-balance.js';

mount([g0]);
